/**
 * @copyright: 2020 NTWIST
 * @Author: NTWIST
 * @Date: 2021-03-15 11:07:50
 * @Last Modified by: Pradeep Chandra
 * @Last Modified time: 2022-06-21 20:11:18
 */

import axios from "axios";
import { toaster, Message } from "rsuite";
import React from "react";
import BaseURL from "../api-common";

export async function getAllTags(endUserSession) {
    try {
        let url = BaseURL.getBaseURL() + "/production/tagManagement/getAllTags";

        let res = await axios({
            method: "get",
            url: url,
            withCredentials: true,
            data: {}
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return res.data.tags;
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={1500}>
                {
                    <text>
                        Could not get all tags.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}

export async function getPredictionModelTargetTag(endUserSession) {
    try {
        let url =
            BaseURL.getBaseURL() +
            "/production/tagManagement/getPredictionModelTargetTag";

        let res = await axios({
            method: "get",
            url: url,
            withCredentials: true,
            data: {}
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return res.data.targetTag;
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={1500}>
                {
                    <text>
                        Could not get prediction model target tag.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}
